// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { ProjectTemplateDeliverable } from "../../types";

const projectTemplateDeliverablesModule = {
  async findByProjectTemplateId(projectTemplateId: string): Promise<ProjectTemplateDeliverable[]> {
    const result = await sql`
      SELECT * FROM project_template_deliverables
      WHERE project_template_id = ${projectTemplateId}
      ORDER BY position ASC, created_at ASC
    `;
    return (result || []) as ProjectTemplateDeliverable[];
  },

  async create(data: Omit<ProjectTemplateDeliverable, 'id' | 'created_at'>): Promise<ProjectTemplateDeliverable> {
    const result = await sql`
      INSERT INTO project_template_deliverables (project_template_id, goal_template_id, position)
      VALUES (${data.project_template_id}, ${data.goal_template_id}, ${data.position})
      RETURNING *
    `;
    return result[0] as ProjectTemplateDeliverable;
  },

  async delete(id: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM project_template_deliverables
      WHERE id = ${id}
    `;
    return result.count > 0;
  },

  async deleteByProjectTemplateId(projectTemplateId: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM project_template_deliverables
      WHERE project_template_id = ${projectTemplateId}
    `;
    return result.count > 0;
  }
};

export type ProjectTemplateDeliverablesModule = typeof projectTemplateDeliverablesModule;

export function registerProjectTemplateDeliverables(db: { projectTemplateDeliverables?: ProjectTemplateDeliverablesModule }) {
  db.projectTemplateDeliverables = projectTemplateDeliverablesModule;
}

export { projectTemplateDeliverablesModule as projectTemplateDeliverables };
